import { render, staticRenderFns } from "./RegiaoMunicipioForm.vue?vue&type=template&id=5edd2bb6"
import script from "./RegiaoMunicipioForm.vue?vue&type=script&lang=js"
export * from "./RegiaoMunicipioForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports